<ng-container *ngIf="hasPermission(); else denied">
  <ng-content></ng-content>
</ng-container>

<ng-template #denied>
  <permissions-denied class="w-full"></permissions-denied>
</ng-template>
